/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import moment from 'moment';
import { toHeaderCase } from 'js-convert-case';
import { apiConfig } from '@pages/ProvisionalPage/config/api.config';
import { provisionalListConfig } from '@pages/ProvisionalPage/config/provisionalLists.config';
import { GET_POLICY_LIST } from '@pages/ProvisionalPage/api/graphql';

const lookup = require('country-code-lookup');
const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(AppNavigatorService.name);
};

export interface IDownloadPolicyPluginMethods extends IPluginMethodMap {
  getDownloadPolicy(args?: any): Promise<any>;
}

export interface IGetProvisionalListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class DownloadPolicyPlugin implements IAgentPlugin {
  readonly methods: IDownloadPolicyPluginMethods;
  constructor() {
    this.methods = {
      getDownloadPolicy: this.getDownloadPolicy.bind(this),
    };
  }

  async getDownloadPolicy(args?: IGetProvisionalListProps) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
    const token = getWhoamiSrv()?.getToken();
    // const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .query(GET_POLICY_LIST, {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 1000,
            where: [
              {
                column: 'type',
                value: ['PROVISIONAL'],
                op: 'Equal',
              },
              {
                column: 'status',
                value: ['PAYMENT_PENDING'],
                op: 'In',
              },
            ],
            order: [
              {
                column: 'purchasedAt',
                direction: 'DESC',
              },
            ],
          })
          .toPromise();
        if (res?.data) {
          let _rowData = this.formatTable(res?.data?.getListOfPolicies?.data);
          return {
            ...provisionalListConfig,
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in update profile=', err?.message);
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          vid: item?.purchasedBy?.vuid,
          policyNo: item?.policyNumber,
          country:
            item?.countryToBeInsured && item?.countryToBeInsured.length === 2
              ? lookup.byIso(`${item?.countryToBeInsured}`)?.country
              : '-',
          name: `${toHeaderCase(
            item?.purchasedBy?.firstName ?? ''
          )} ${toHeaderCase(item?.purchasedBy?.lastName ?? '')}`,
          email: item?.purchasedBy?.email,
          // image:item?.image,
          dateCreated: item?.purchasedAt
            ? moment(item?.purchasedAt).format('LLL')
            : '-',
          coverage: item?.coverage,
          premium: item?.premium,
          discount:
            item?.discountedPremium && item?.discountedPremium !== item?.premium
              ? item?.discountedPremium
              : 'NA',
          policyOption: `Policy Option ${item?.productDefination}`,
        };
      });
    return _rowData;
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
